export const BasicStyle =
  `w-[48.4rem] h-[4.8rem] border border-[#D9D9D9] bg-[#FFF] rounded-[0.6rem] p-[1.5rem] mb-[2.8rem] text-[#333236] outline-none text-[1.6rem]` as const;
